import React from 'react'

import { Form, Col } from '_zari/core'

const CostoPromedioFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='COSTO PROMEDIO' htmlFor='input-costoPromedio' xs={12} />
      <Col xs={12}>
        <Form.InputText defaultValue={iValue} disabled id='input-costoPromedio' name='costoPromedio' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CostoPromedioFormGroup)
